export default {
  activity_food_01: {
    title: 'Jeg har ikke kastet mat i dag',
    description:
      'Kan logges på dager du spiser eller sparer restemat i stedet for å kaste den. Du kan spare restene, lage et godt måltid av dem eller kjøpe riktig mengde mat når du er i butikken.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- I Norge kastes det [417 000 tonn mat i året](https://www.matvett.no/uploads/documents/OR.32.19-Matsvinn-i-Norge-Rapportering-av-nokkeltall-2015-2018-08.11.2019.pdf), og over halvparten av svinnet skjer i husholdninger.
- Maten som kastes i husholdninger er stort sett måltidsrester og bakevarer - med litt planlegging kunne mye blitt unngått! 
- Matproduksjon fører ca [26% av klimagassutslipp i verden](https://ourworldindata.org/environmental-impacts-of-food#), om om vi kaster mindre krever dette også at mindre produseres.

## Hva vi antar
- Besparelsen beregnes ut fra forskjellen mellom hvor mye mat en gjennomsnittlig person i landet ditt kaster og en person som ikke kaster mat. Gjennom å redusere matavfall på individnivå, vil ikke maten som kastes måtte produseres, og du bidrar til å redusere klimagassutslipp tilsvarende utslippet fra å produsere denne mengden mat. Vi finner mengde gjennomsnittlig matavfall fra landspesifikke studier. Sjekk klimakalkulatoren og dens dokumentasjon for å se hvor mye dette er for ditt land.

## Tilleggsinformasjon
- [Tips til hvordan du kan kaste mindre](https://www.framtiden.no/tips/slik-reduserer-du-matsvinnet-hjemme)
- [Video om matsvinn](https://www.youtube.com/watch?v=rm7SysrOI-Y)`,
    health_explanation: `MARKDOWN:
## Fakta
- Gjennom å kaste mindre mat bidrar du til å bekjempe underernæring og sult i andre land.

## Tilleggsinformasjon
- [https://blogs.plos.org/publichealth/2013/01/15/food-waste/](https://blogs.plos.org/publichealth/2013/01/15/food-waste/)`,
  },
  activity_food_02: {
    title: 'Jeg spiste vegetarisk i dag',
    description:
      'Kan logges på dager du ikke har spist kjøtt eller fisk i løpet av en hel dag.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Kjøttproduksjon er en stor kilde til klimagassutslipp, hovedsakelig på grunn av metan som slippes ut av drøvtyggere som kyr og sau, og avskoging for å øke beiteareal.
- Det er store forskjeller på type kjøtt og hvordan det er produsert. Det er bedre for klima om du spiser viltkjøtt framfor industriell kjøtt, og kylling framfor storfe og sau.
- Ved å teste ut plantebaserte retter og innføre det i ditt kosthold, vil du bidra til en viktig reduksjon i klimagassutslipp.

## Hva vi antar
- Beregningen er gjort ved å fjerne ditt kaloriinntak fra kjøttprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.

## Tilleggsinformasjon
- [Spis mer plantebasert](https://www.framtiden.no/tips/ti-plantebaserte-hverdagsmiddager)
`,
    health_explanation: `MARKDOWN:
## Tilleggsinformasjon
- [Les mer fra Helse Norge](https://www.helsenorge.no/kosthold-og-ernaring/vegetarisk-kosthold/naringsrik-vegetarkost/#helsegevinster-og-utfordringer-med-vegetarkost-og-vegankost) om helsegevinster ved en vegetarisk kosthold, og hvordan du kan sikrer at du dekker behover for energi og næringsstoffer mens du spiser vegetarsk eller vegansk.`,
  },
  activity_food_03: {
    title: 'Jeg har spist mindre meieriproduker i dag',
    description:
      'Kan logges på dager du spiser mindre enn 200 gram meieriprodukter (tilsvarer ett glass melk).',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Kjøttproduksjon er en stor kilde til klimagassutslipp, hovedsakelig på grunn av metan som slippes ut av drøvtyggere som kyr og sau, og avskoging for å øke beiteareal.
- Melk, yoghurt og ost har et høyt utslipp per kalori. Visste du at det i dag finnes gode alternativer til meieriprodukter laget av blant annet havre, ris, nøtter og soya? 

## Hva vi antar
- Beregningen er gjort ved å fjerne ditt kaloriinntak fra kjøtt, fisk og meieriprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.

## Tilleggsinformasjon
- [https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html](https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html)`,
    health_explanation: `MARKDOWN:
## Tilleggsinformasjon
- [Les mer fra Helse Norge](https://www.helsenorge.no/kosthold-og-ernaring/vegetarisk-kosthold/naringsrik-vegetarkost/#helsegevinster-og-utfordringer-med-vegetarkost-og-vegankost) om helsegevinster fra en vegetarisk kosthold, og hvordan du kan sikrer at du dekker behover for energi og næringsstoffer mens du spiser vegetarsk eller vegansk.`,
  },
  activity_food_04: {
    title: 'Jeg spiste fisk i stedet for kjøtt i dag',
    description:
      'Kan logges på dager du erstatter kjøtt med bærekraftig fisk til alle måltider.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- [Sjømat har generelt et mindre fotavtrykk enn kjøtt](https://www.sintef.no/contentassets/25338e561f1a4270a59ce25bcbc926a2/report-carbon-footprint-norwegian-seafood-products-2017_final_040620.pdf/). Men sjekke at fisken kommer fra miljøsertifisert sjømatproduksjon! Sild, makrell, torsk eller sei har for eksempel et betydelig lavere fotavtrykk enn oppdrettslaks.
- Økosystemene i havet sliter med overfiske, tråling (ødelegging av havbunn) og negativ påvirkning fra oppdrettsnæringen. Ved å spise bærekraftige fiskemåltider bidrar du til å støtte de gode aktørene og til å endre næringen i en mer bærekraftig retning.

## Hva vi antar
- Beregningen er gjort ved å fjerne ditt kaloriinntak fra kjøttprodukter for en gjennomsnittlig innbygger i ditt land og overføre disse kaloriene til fiskeprodukter.

## Tilleggsinformasjon
- [Gjør bevisste valg av fisk og sjømat](https://www.framtiden.no/tips/dette-er-verdens-mest-baerekraftige-fiskemat)`,
    health_explanation: `MARKDOWN:
## Tilleggsinformasjon
- [Les mer fra Helse Norge](https://www.helsenorge.no/kosthold-og-ernaring/kostrad/spis-fisk-oftere/) om helsegevinster ved fisk i kostholdet`,
  },
  activity_food_05: {
    title: 'Jeg kastet ikke mat i dag',
    description: `Registreres hvis du ikke kastet noe mat.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Vi kaster 42,6 kg mat per person i året.

## Finn ut mer
- [https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479](https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479)`,
  },
  activity_food_06: {
    title: 'Jeg sjekket hva jeg hadde før jeg gikk på butikken i dag',
    description: `Registreres hvis du sjekket kjøleskapet, fryseren og matskapet før du handlet mat på butikken.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    time_explanation: `MARKDOWN:
## Visste du at?
- Danske forbrukere bruker i gjennomsnitt mellom 4 og 5 timer i måneden på å handle mat som ender i søpla.

## Finn ut mer
- [https://ourworld.unu.edu/en/if-everybody-hates-wasting-food-why-do-we-and-how-can-we-stop](https://ourworld.unu.edu/en/if-everybody-hates-wasting-food-why-do-we-and-how-can-we-stop)`,
    money_explanation: `MARKDOWN:
## Visste du at?
- Hver nordmann kaster i gjennomsnitt hver 8. handlepose med mat
- Hver av oss i snitt kaster mat til en verdi av ca 2 677 kroner hvert år

## Finn ut mer
- [https://www.miljodirektoratet.no/Documents/publikasjoner/M1016/M1016.pdf](https://www.miljodirektoratet.no/Documents/publikasjoner/M1016/M1016.pdf)`,
  },
  activity_food_07: {
    title: 'Jeg avkjølte mat raskt og riktig i dag',
    description: `Registreres hvis du raskt kjølte ned restemat eller mat fra butikken.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Ved å passe på å først varme opp maten til høy nok temperatur og så være obs på kjøle den raskt ned før du setter den i kjøleskapet, forlenger du holdbarheten på restene.
- Flere kjølevarer har en Keep-it-indikator som registrerer om kjølekjeden er passet på og viser den faktiske holdbarheten til varen?
- Du bør kjøle ned mat f.eks. i vannbad før du setter det i kjøleskapet? Hvis ikke kan temperaturen øke i hele kjøleskapet og gjøre resten av maten der dårlig.

## Finn ut mer
- [https://www.matvett.no/brukopp-leksikon/middagsrester](https://www.matvett.no/brukopp-leksikon/middagsrester)
- [https://www.keep-it.no](https://www.keep-it.no)`,
  },
  activity_food_08: {
    title: 'Jeg brukte handleliste i dag',
    description: `Registreres hvis du fulgte en plan for handleturen i dag.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    money_explanation: `MARKDOWN:
## Visste du at?
- Å handle uten en plan kan føre til mer mat i handlekurven enn du får spist opp i tide, og er en av grunnene til at vi bruker mer penger på mat. 
- Det er flere måter å lage en handleliste på som hjelper deg bruke penger på det du trenger. For eksempel kan du ta et bilde av kjøleskapet før du drar, slik at du ser det du ikke  ikke trenger å handle- en slags «motsatt handleliste». Eller bruk en av mange handle-apper, som du også kan oppdatere og dele med andre i husholdningen for bedre planlegging.

## Finn ut mer
- [https://www.dnbnyheter.no/privatokonomi/spar-penger-med-en-matplan/](https://www.dnbnyheter.no/privatokonomi/spar-penger-med-en-matplan/)
- [https://www.dinside.no/mobil/gjor-det-mye-enklere-a-fa-med-seg-alt-pa-handlelista/67093692](https://www.dinside.no/mobil/gjor-det-mye-enklere-a-fa-med-seg-alt-pa-handlelista/67093692)`,
  },
  activity_food_09: {
    title: 'Jeg lagde en matplan for uka i dag',
    description: `Registreres hvis du lagde, handler for og/eller fulgte en matplan for uka.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- 1 av 12 sier de kjøper mer og flere varer enn de hadde tenkt, hver gang de handler mat.
- Å planlegge måltidene for uka, med råvarer som passer til flere middager, kan spare dere tid, penger, energi og matsvinn.
- Planer kan endre seg og at det kan være lurt å legge inn en eller to «åpne dager», hvor dere spiser rester, spiser ute, takeaway, er på middagsbesøk e.l.
- Lag en fleksibel plan som gjør det mulig å flytte rundt på middagsplanene, f.eks. avhengig av hvor god tid dere har hver dag.

## Finn ut mer
- [https://fil.forbrukerradet.no/wp-content/uploads/2016/09/rapport-handlevaner-og-holdbarhetsdato-2016.pdf](https://fil.forbrukerradet.no/wp-content/uploads/2016/09/rapport-handlevaner-og-holdbarhetsdato-2016.pdf)

## Inspirasjon
- [https://spar.no/Nyheter/middag-uten-matsvinn/](https://spar.no/Nyheter/middag-uten-matsvinn/)`,
  },
  activity_food_10: {
    title: 'Jeg spiste restemat i dag',
    description: `Registreres hvis du brukte rester i ett eller flere måltider i dag.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Restemat er den kategorien med mat vi kaster aller mest av?
- Hver nordmann kaster hvert år i gjennomsnitt 13 kg restemat fra gryter, tallerkener og restematbokser?

## Finn ut mer
- [https://restemat.blogspot.com](https://restemat.blogspot.com)`,
  },
  activity_food_11: {
    title: 'Jeg stolte på sansene mine i dag',
    description: `Registreres hvis du så, luktet eller smakte på maten for å vurdere om den fortsatt var spiselig.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- «Utgått på dato» er det flest nordmenn oppgir som årsak til at de kaster mat.
- Det er forskjell på merkingene Best før og Siste forbruksdag. 
- Det er mye viktigere hvordan maten har vært oppbevart enn utløpsdatoen? Ville du for eksempel drukket en melk som ikke var utgått på dato, men som hadde stått åpent på kjøkkenbenken en uke, heller enn en «utgått» melk som var holdt kaldt?

## Effekt
- Denne aktiviteten hjelper deg å gjennomføre "Jeg har ikke kastet mat i dag", som har CO\u2082-beregning. 

## Finn ut mer
- [https://www.framtiden.no/201609097040/aktuelt/mat/sa-lenge-holder-best-for-maten.html](https://www.framtiden.no/201609097040/aktuelt/mat/sa-lenge-holder-best-for-maten.html)
- [https://www.matvett.no/uploads/documents/Matsvinn-i-Norge-Rapportering-av-nokkeltall-2015-2017.pdf](https://www.matvett.no/uploads/documents/Matsvinn-i-Norge-Rapportering-av-nokkeltall-2015-2017.pdf)`,
  },
  activity_food_12: {
    title: 'Jeg snakket med noen om matsvinn i dag',
    description: `Registreres hvis du fortalte noen om MatVinn eller delte et godt matsvinn-tips.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Visste du at?
- 8 av 10 nordmenn sier de får dårlig samvittighet av å kaste mat? Likevel kvier mange seg for å si ifra og ta vare på mat andre vil kaste etter f.eks. en hyttetur eller middagsselskap, av frykt for å virke gnien eller gammeldags.
- Å kaste mindre mat er en av våre viktigste - og ofte mest «usynlige» - miljøgjerninger? Hvis flere snakker om fordelene med å kaste mindre mat og hvor lite som skal til, kan du være med å bryte ned fordommene.

## Finn ut mer
- [https://www.duo.uio.no/bitstream/handle/10852/50412/Master-thesis-Elisabeth-Riise-Jenssen.pdf?sequence=1](https://www.duo.uio.no/bitstream/handle/10852/50412/Master-thesis-Elisabeth-Riise-Jenssen.pdf?sequence=1)`,
  },
  activity_food_13: {
    title: 'Jeg snakket med barna om matsvinn i dag',
    description: `Registreres hvis du snakket med barna om hvorfor vi bør kaste mindre mat.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Visste du at?
- Det er ekstra viktig å unngå pekefinger og skyldfølelse om mat ovenfor barn.
- Å snakke om «matens reise» (for eksempel en banan) fra jord til tallerkenen kan være et fint utgangspunkt for å vise respekt for maten vår.
- Det er lurt å ta matsvinn-praten før man krangler om den siste brokkolibiten ved middagsbordet. Ta det opp i «fredstid».
- Å la barna forsyne seg selv gjør det lettere å snakke om hvorfor det er lurt å ta litt og litt av gangen og kjenne etter hvor mye man orker.`,
  },
  activity_food_14: {
    title: 'Jeg brukte «Spis meg først»-boksen i dag',
    description: `Registreres hvis du tok utgangspunkt i «Spis meg først»-boksen når du skulle ha noe å spise.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Med basisvarer som f.eks. mel, smør, pasta, egg, hermetikk og krydder tilgjengelig, kan du enklere lage et nytt og digg måltid ut av smårester som må spises opp?
- Matvett har laget et eget Brukopp-leksikon, til inspirasjon for hvordan små rester kan bli til digge retter?

## Finn ut mer
- [https://www.matvett.no/brukopp-leksikon](https://www.matvett.no/brukopp-leksikon)`,
  },
  activity_food_15: {
    title: 'Jeg oppbevarte maten riktig i dag',
    description: `Registreres hvis du plasserte maten der den holder seg best.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøleskapet bør holde mellom 2-4 grader og har ulik temperatur i topp og bunn? Plasser maten etter hvilken temperatur den tåler best.
- Blant annet holder bananer, avocado, tomater seg lenger utenfor kjøleskapet. 
- Epler, plommer og tropisk frukt inneholder etylengass, som påvirker holdbarheten til maten rundt. De bør derfor ikke ligge for nær følsomme frukter som banan og avocado. Poteter har lignende påvirkning på løk, så de bør også holdes adskilt.
- Hvis du har et vinskap, kan det ha optimal temperatur for å oppbevare frukt som trives best i «mellomtemperatur», som bl.a. banan og agurk.

## Finn ut mer
- [https://www.matprat.no/artikler/oppbevaring-og-holdbarhet/hvor-i-kjoleskapet-bor-maten-sta/](https://www.matprat.no/artikler/oppbevaring-og-holdbarhet/hvor-i-kjoleskapet-bor-maten-sta/)
- [https://www.dagbladet.no/mat/forskningssjef---pass-deg-for-bananfella/70013611](https://www.dagbladet.no/mat/forskningssjef---pass-deg-for-bananfella/70013611)
- [https://www.frukt.no](https://www.frukt.no)`,
  },
  activity_food_16: {
    title: 'Jeg tok vare på rester i dag',
    description: `Registreres hvis du tok vare på alt stort og smått etter dagens måltider.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    time_explanation: `MARKDOWN:
## Visste du at?
- Det er mye tid, penger og mat å redde ved å ha maten som må spises først samlet på et lett tilgjengelig sted. 
- Rester trenger ikke å spises i akkurat samme form dagen etter. Det kan enkelt forvandles til noe nytt og digg.`,
  },
  activity_food_17: {
    title: 'Jeg spiste opp matpakka mi i dag',
    description: `Registeres hvis du ikke kastet noe av maten fra matpakka.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Visste du at?
- Å spise mat på skolen er viktig for barnas konsentrasjon, læring og mestring.
- Mange matpakker kan bli reddet fra søpla hvis barna får være med å bestemme hva den skal inneholde? Kanskje kan de være med å lage den kvelden før og kanskje kan skolen gi barna god nok tid til å spise. Ta matpakkepraten med barna for å finne grunnen til at matpakka ikke blir spist.

## Finn ut mer
- [https://helsenorge.no/kosthold-og-ernaring/mat-for-barn/skolemat](https://helsenorge.no/kosthold-og-ernaring/mat-for-barn/skolemat)
- [https://www.dagbladet.no/mat/tusenvis-av-barn-kaster-matpakka---alle-gjor-den-samme-tabben-ved-skolestart/68597135](https://www.dagbladet.no/mat/tusenvis-av-barn-kaster-matpakka---alle-gjor-den-samme-tabben-ved-skolestart/68597135)
- [https://www.melk.no/Kosthold-og-helse/Skole/Slik-kan-du-variere-en-sunn-matpakke](https://www.melk.no/Kosthold-og-helse/Skole/Slik-kan-du-variere-en-sunn-matpakke)`,
    landuse_explanation: `MARKDOWN:
## Visste du at?
- Nordmenn kaster i gjennomsnitt 100 000 brød hver dag.
- For å dyrke korn til ett brød kreves over to kvadratmeter matjord.

## Finn ut mer
- [https://kiwi.no/tema/kast-mindre-mat/slik-unngar-du-a-kaste-brod/](https://kiwi.no/tema/kast-mindre-mat/slik-unngar-du-a-kaste-brod/)`,
  },
  activity_food_18: {
    title: 'Jeg valgte mindre pakningsstørrelser i dag',
    description: `Registreres hvis du kjøpte mindre pakninger som passer dere bedre.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    landuse_explanation: `MARKDOWN:
## Visste du at?
- Nordmenn kaster i gjennomsnitt 100 000 brød hver dag.
- For å dyrke korn til ett brød kreves over to kvadratmeter matjord.

## Finn ut mer
- [https://kiwi.no/tema/kast-mindre-mat/slik-unngar-du-a-kaste-brod/](https://kiwi.no/tema/kast-mindre-mat/slik-unngar-du-a-kaste-brod/)`,
  },
  activity_food_19: {
    title: 'Jeg merket overskuddsmat i dag',
    description: `Registreres hvis du skrev på dato og innhold på restematen.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Fryseren kan være en kjempehjelp for å unngå matsvinn, men at umerket mat i kjøleskap og fryser kan føre til mange UFO’er (uidentifiserbare frosne objekter) og mye matsvinn.
- Det også er smart å ha en fast plass til rester i fryseren, så du unngår å lete etter maten. 
- Å ha en maskeringsteip og penn liggende på kjøkkenbenken, gjør det kjapt og enkelt å merke mat og lett å fjerne igjen når det er spist opp.

## Finn ut mer
- [https://www.youtube.com/watch?v=B6mi-ZFCprs](https://www.youtube.com/watch?v=B6mi-ZFCprs)`,
  },
  activity_food_20: {
    title: 'Jeg justerte mengden mat i dag',
    description: `Registreres hvis du justerte mengeden mat etter å ha lagt merke til hvor mye som ble igjen forrige gang.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Mange av oss beregner etter vane og legger ikke merke til at det ofte blir like mye rester igjen.
- Enkle verktøy som pastamåler, desilitermål eller justerbare internettoppskrifter kan hjelpe til med å justere porsjonene.
- Det er lurt å ha frukt liggende i tilfelle man er ekstra sultne en dag.

## Finn ut mer
- [https://www.lovefoodhatewaste.com/portion-planner#portion_calculator](https://www.lovefoodhatewaste.com/portion-planner#portion_calculator)`,
  },
  activity_food_21: {
    title: 'Jeg unngikk å handle på tom mage i dag',
    description: `Registreres hvis du sørget for at ingen i handlefølget var skrubbsultne.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    money_explanation: `MARKDOWN:
## Visste du at?
- Vi kjøper ofte mer mat enn vi trenger hvis vi handler mens vi er sultne. 
- Å ha en pose nøtter eller snacksgulerøtter tilgjengelig, kan gjøre handleturen billigere, mer miljøvennlig og hyggeligere for både store og små.

## Finn ut mer
- [https://www.lovefoodhatewaste.com/portion-planner#portion_calculator](https://www.lovefoodhatewaste.com/portion-planner#portion_calculator)`,
  },
  activity_food_22: {
    title: 'Jeg inkluderte barna i matlaginga i dag',
    description: `Registeres hvis barna var med å lage et eller flere av dagens måltider.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Visste du at?
- Å inkludere barna i matlagingen og hva som skal til for at maten kommer på tallerkenen vår kan øke motivasjonen for å spise opp?

## Inspirasjon
- [https://www.rema.no/nyheter/derfor-bor-barna-vaere-med-pa-matlagingen/](https://www.rema.no/nyheter/derfor-bor-barna-vaere-med-pa-matlagingen/)`,
  },
  activity_food_23: {
    title: 'Jeg hjalp butikken å unngå matsvinn i dag',
    description: `Registreres hvis du bidro til at mat ikke måtte kastes fra butikken.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Norske dagligvarebutikker kaster mer enn 60.000 tonn mat hvert år. 
- Butikkene må kaste kjølevarer som er lagt igjen andre steder på vei til kassa, hvis de ikke vet hvor lenge den har ligget der.
- Norske butikker kaster 60.000 bananer hver dag. Mye av grunnen er at ingen velger de enslige bananene, selv om vi bare skal kjøpe én.
- Når du kjøper mat du vet du skal bruke snart, bidrar du til mindre matsvinn hvis du kjøper den med kortest holdbarhetsdato.
- Hvis du klemmer for hardt på avokadoen, kan de lett få skader som gjør at de må kastes. 
- Hvis du plukker og blander smågodt eller nøtter og ombestemmer deg og setter det igjen, er butikken nødt til å kaste det.

## Finn ut mer
- [https://www.framtiden.no/201609077035/aktuelt/mat/butikkene-kaster-60.000-bananer-hver-dag.html](https://www.framtiden.no/201609077035/aktuelt/mat/butikkene-kaster-60.000-bananer-hver-dag.html)
- [https://www.framtiden.no/201706237165/aktuelt/mat/butikker-kaster-mat-de-kunne-gitt-til-trengende.html](https://www.framtiden.no/201706237165/aktuelt/mat/butikker-kaster-mat-de-kunne-gitt-til-trengende.html)`,
  },
  activity_food_24: {
    title: 'Jeg reddet kjøtt eller fisk fra å havne i søpla i dag',
    description: `Registreres hvis du ikke kastet kjøtt eller fisk.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøttproduksjon står for ca. 15 % av de globale klimagassutslippene.
- Ferskt kjøtt, fisk og sjømat er som oftest merket med “siste forbruksdag”. Hvis den er oppbevart riktig, er den allikevel ofte trygg å spise også forbi datoen. Bruk sansene dine til å vurdere!
- Bakteriene angriper kjøttet fra utsiden, så det er stor forskjell på holdbarhet av farseprodukter og hele kjøttstykker. Farseprodukter som kjøttdeig og leverpostei bør du være mer forsiktig med etter utløpsdatoen, fordi de lettere får bakteriedannelser. Hele kjøttstykker blir derimot ofte mørere jo eldre det er. Profesjonelle kokker foretrekker ofte kjøtt som nærmer seg eller har gått over utløpsdatoen.
- Kjøttprodukter har ofte en stram lukt med det samme du åpner pakken, som du ikke bør la deg lure av. Vent et par minutter og kjenn etter om det fortsatt lukter vondt. Da skal du være forsiktig med å spise den.

## Finn ut mer
- [https://www.framtiden.no/gronne-tips/mat/sjekk-hvilken-mat-som-er-best-for-miljoet.html](https://www.framtiden.no/gronne-tips/mat/sjekk-hvilken-mat-som-er-best-for-miljoet.html)`,
  },
  activity_food_25: {
    title: 'Jeg reddet grønnsaker fra å havne i søpla i dag',
    description: `Registreres hvis du ikke kastet grønnsaker.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Vi kaster i gjennomsnitt 11,3 kg frukt og grønt per person i året.
- Slapp salat og gulrøtter kan bli friske og stive igjen av å ligge i iskaldt vann i en bolle noen minutter.
- Litt sitron eller lime på salat eller andre grønnsaker kan bidra til at det holder seg friskt lenger.
- Slappe grønnsaker er supergode i supper, sauser, gryter eller bakt i ovnen.

## Inspirasjon
- [https://www.kk.no/livstil/fa-liv-i-slappe-gronnsaker/67917470](https://www.kk.no/livstil/fa-liv-i-slappe-gronnsaker/67917470)`,
    health_explanation: `MARKDOWN:
## Visste du at?
- Å kjøre grønnsaker i en stavmikser og blande det inn i pizzasaus, supper osv., kan være en lur måte å snike inn mer grønnsaker i barnas og ditt eget kosthold.

## Finn ut mer
- [https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479](https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479)`,
  },
  activity_food_26: {
    title: 'Jeg reddet frukt i dag',
    description: `Registreres hvis du ikke kastet frukt.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Vi kaster 11,3 kg frukt og grønt per person i året?
- Slapp og brun frukt kan brukes i bakst, smoothies eller fryses ned og lages til noe godt senere.

## Finn ut mer
- [https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479](https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479)
- [https://www.nrk.no/viten/disse-fruktene-og-gronnsakene-kastes-det-mest-av-1.13852697](https://www.nrk.no/viten/disse-fruktene-og-gronnsakene-kastes-det-mest-av-1.13852697)

## Inspirasjon
- [https://www.melk.no/Inspirasjon/Restemat/Gode-tips-til-hva-du-kan-lage-med-overmoden-frukt-og-baer](https://www.melk.no/Inspirasjon/Restemat/Gode-tips-til-hva-du-kan-lage-med-overmoden-frukt-og-baer)`,
  },
  activity_food_27: {
    title: 'Jeg reddet meieriprodukter i dag',
    description: `Registreres hvis du ikke kastet meieriprodukter.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Vi kaster 2,7 kg meieriprodukter per person i året.
- Det meste av meieriprodukter er merket med Best før, og ofte er god lenge etter holdbarhetsdatoen.
- Mange meieriprodukter er «sure» eller vellagret i utgangspunktet, som for eksempel yoghurt, rømme og ost.
- Melk, rømme og yoghurt som har gått utover holdbarhetsdatoen fint kan brukes i f.eks. vafler, kaker eller smoothies.
- Osterester er perfekt for å også redde annen restemat, ved å gratinere det i ovnen.
- Egg holder seg som regel lenge etter holdbarhetsdatoen, men at det kan være lurt å «kakke» det i et glass for seg selv for å vurdere med egne sanser.

## Finn ut mer
- [https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479](https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479)

## Inspirasjon
- [https://www.melk.no/Inspirasjon/Restemat](https://www.melk.no/Inspirasjon/Restemat)`,
  },
  activity_food_28: {
    title: 'Jeg reddet brød og bakst i dag',
    description: `Registreres hvis du ikke kastet brød og bakst.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Vi kaster 8 kg brød og andre bakevarer per person i året.
- Tørt brød kan bli godt igjen som toast, krutonger, panering, grateng, til desserter eller som kakebunn.
- Flere butikker selger mindre brød for å bidra til mindre svinn.
- Ved å skjære opp og fryse ned brød, kan du kjapt få så godt som ferske brødskiver hver dag.

## Finn ut mer
- [https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479](https://www.ostfoldforskning.no/no/publikasjoner/Publication/?id=2479)

## Inspirasjon
- [https://kiwi.no/tema/kast-mindre-mat/slik-unngar-du-a-kaste-brod/](https://kiwi.no/tema/kast-mindre-mat/slik-unngar-du-a-kaste-brod/)`,
  },
  activity_food_29: {
    title: 'Jeg laget et måltid av matrester i dag',
    description: `Registreres hvis du fant på en ny måte å bruke overskuddsmat på.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Du trenger ikke være gourmetkokk for å lage god mat av restemat. Det finnes mye inspirasjon på nett som hjelper deg å lage noe godt av det du har.
- Å ha fast restetorsdag er en god måte å bli kvitt restene før helga.
- RIKS (rydd i kjøleskapet-suppe), restewraps eller restepannekaker ofte er en hit for både store og små.

## Inspirasjn
- [https://spar.no/Nyheter/middag-uten-matsvinn/](https://spar.no/Nyheter/middag-uten-matsvinn/)`,
  },
  activity_food_30: {
    title: 'Jeg fant på et nytt MatVinn-triks i dag',
    description: `Registreres hvis du oppdaget et nytt triks for å kaste mindre mat.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Visste du at?
- Spør folk rundt deg om å dele deres beste matsvinn tips. Det kan være en god måte å få igang samtalen rundt matsvinn.
- Kanskje lærer du noe du ikke hadde tenkt på, samtidig som du gjør de rundt deg bevisst på at du bryr deg om å redusere matsvinn.`,
  },
  activity_food_31: {
    title: 'Jeg porsjonerte riktig i dag',
    description: `Registreres hvis du posjonerte så det ikke ble mat igjen på tallerkenen.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Mange porsjonerer etter hva som ser finest ut på tallerken og ikke etter hva vi orker å spise.
- Å servere litt og oftere kan øke matlysten hos småspiste.
- Å bruke litt mindre tallerken kan bidra til mindre matsvinn.`,
  },
  activity_food_32: {
    title: 'Jeg spiste sprøytefri mat i dag',
    description: `Registreres hver dag du har valgt økologisk eller ikke sprøytet mat.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Sprøytemidler påvirker habitater og bidrar til tap av biologisk mangfold, inkludert store reduksjoner av insektpopulasjoner.
- Sprøytemidler bidrar også til andre former for miljøforringelse, inkludert luft- og vannforurensning og jordforurensning.
- Det meste av soyaen i norsk oppdrettslaks kommer fra Brasil. De har det høyeste forbruket av sprøytemidler i verden og soyindustrien står for halvparten av dette forbruket. Sprøytemidler som er ulovlige i Europa blir brukt i Brasil. Sprøytingen skjer i stor grad med fly og kan foregå 100 meter fra bebyggelse, barneskoler og drikkevannskilder.

## Les mer
- [https://documents-dds-ny.un.org/doc/UNDOC/GEN/G17/017/85/PDF/G1701785.pdf?OpenElement](https://documents-dds-ny.un.org/doc/UNDOC/GEN/G17/017/85/PDF/G1701785.pdf?OpenElement)
- [https://www.theguardian.com/environment/2019/feb/10/plummeting-insect-numbers-threaten-collapse-of-nature](https://www.theguardian.com/environment/2019/feb/10/plummeting-insect-numbers-threaten-collapse-of-nature)
- [https://www.framtiden.no/201703157119/aktuelt/mat/det-norske-lakseeventyret-blir-fort-et-mareritt-for-brasil.html](https://www.framtiden.no/201703157119/aktuelt/mat/det-norske-lakseeventyret-blir-fort-et-mareritt-for-brasil.html)`,
    health_explanation: `MARKDOWN:
## Visste du at?
- Sprøytemidler er potensielt giftige for mennesker og kan ha både akutte og kroniske helseeffekter, avhengig av mengde og måtene en person blir utsatt for de på.
- Personer som står overfor den største helserisikoen ved eksponering for sprøytemidler er de som kommer i kontakt med dem på jobb, hjemme eller i hagen.

## Finn ut mer
- [https://www.who.int/news-room/fact-sheets/detail/pesticide-residues-in-food](https://www.who.int/news-room/fact-sheets/detail/pesticide-residues-in-food)`,
  },
  activity_food_33: {
    title: 'Jeg spiste vegetarfrokost i dag',
    description: `Registreres hver dag du ikke spiser kjøtt eller fisk til frokost.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøttproduksjon fører til store CO\u2082e- utslipp på grunn av fôrdyrkingen (som i stor grad består av soya og mais), metanutslipp gjennom raping fra drøvtyggere og hugging av regnskog.
- Det er store forskjeller på type kjøtt og hvordan kjøttet er fremstilt. Eksempelvis vil det være mye bedre for klimagassutslippene om du spiser viltkjøtt enn kjøtt fra storindustri, og kylling fremfor storfe og sau.
- Ved å teste ut plantebaserte retter i kostholdet ditt bidrar du til en viktig reduksjon i klimagassutslipp.

## Dokumenterte effekter
- Beregningen er gjort ved å fjerne ditt kaloriinntaket fra kjøttprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.
- Vi har lagt til grunn at 20% av kaloriintaket kommer fra frokost. 

## Les mer
- [https://static.ducky.eco/calculator_documentation.pdf](https://static.ducky.eco/calculator_documentation.pdf)

## Tips til å komme i gang
- [https://vegetarmat.org/type/frokost/](https://vegetarmat.org/type/frokost/)`,
    health_explanation: `MARKDOWN:
## Visste du at?
- Ved å redusere kjøttforbruket kan du minske risikoen for alvorlige sykdommer som hjerte- og karsykdommer, kreft og diabetes.
- Kroppen din bli kjempeglad for alle fibrene, vitaminene og næringsstoffene som finnes i et mer plantebasert kosthold.

## Finn ut mer
- [https://www.health.harvard.edu/staying-healthy/becoming-a-vegetarian](https://www.health.harvard.edu/staying-healthy/becoming-a-vegetarian)`,
  },
  activity_food_34: {
    title: 'Jeg spiste vegetarlunsj i dag',
    description: `Registreres hver dag du har hatt en fiske- og kjøttfri lunsj, men har spist meieriprodukter eller egg.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøttproduksjon fører til store CO\u2082e- utslipp på grunn av fôrdyrkingen (som i stor grad består av soya og mais), metanutslipp gjennom raping fra drøvtyggere og hugging av regnskog.
- Det er store forskjeller på type kjøtt og hvordan kjøttet er fremstilt. Eksempelvis vil det være mye bedre for klimagassutslippene om du spiser viltkjøtt enn kjøtt fra storindustri, og kylling fremfor storfe og sau.
- Ved å teste ut plantebaserte retter i kostholdet ditt bidrar du til en viktig reduksjon i klimagassutslipp.

## Dokumenterte effekter
- Beregningen er gjort ved å fjerne ditt kaloriinntaket fra kjøttprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.
- Vi har lagt til grunn at 35% av kaloriintaket ditt kommer fra lunsj. 

## Les mer
- [https://vegetarmat.org/type/lunsj/](https://vegetarmat.org/type/lunsj/)
- [https://static.ducky.eco/calculator_documentation.pdf](https://static.ducky.eco/calculator_documentation.pdf)

## Tips til å komme i gang
- [https://vegetarmat.org/type/frokost/](https://vegetarmat.org/type/frokost/)`,
    health_explanation: `MARKDOWN:
## Visste du at?
- Ved å redusere kjøttforbruket kan du minske risikoen for alvorlige sykdommer som hjerte- og karsykdommer, kreft og diabetes.
- Kroppen din bli kjempeglad for alle fibrene, vitaminene og næringsstoffene som finnes i et mer plantebasert kosthold.

## Finn ut mer
- [https://www.health.harvard.edu/staying-healthy/becoming-a-vegetarian](https://www.health.harvard.edu/staying-healthy/becoming-a-vegetarian)`,
  },
  activity_food_35: {
    title: 'Jeg spiste vegetar til middag i dag',
    description: `Registreres hver dag du har hatt en fiske- og kjøttfri middag.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøttproduksjon fører til store CO\u2082e- utslipp på grunn av fôrdyrkingen (som i stor grad består av soya og mais), metanutslipp gjennom raping fra drøvtyggere og hugging av regnskog.
- Det er store forskjeller på type kjøtt og hvordan kjøttet er fremstilt. Eksempelvis vil det være mye bedre for klimagassutslippene om du spiser viltkjøtt enn kjøtt fra storindustri, og kylling fremfor storfe og sau.
- Ved å teste ut plantebaserte retter i kostholdet ditt bidrar du til en viktig reduksjon i klimagassutslipp.

## Doumenterte effekter
- Beregningen er gjort ved å fjerne ditt kaloriinntaket fra kjøttprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.
- Vi har lagt til grunn at 45% av kaloriintaket ditt kommer fra middag.

## Les mer
- [https://static.ducky.eco/calculator_documentation.pdf](https://static.ducky.eco/calculator_documentation.pdf)

## Tips til å komme i gang
- [https://trinesmatblogg.no/tag/vegetar/](https://trinesmatblogg.no/tag/vegetar/)`,
    health_explanation: `MARKDOWN:
## Visste du at?
- Ved å redusere kjøttforbruket kan du minske risikoen for alvorlige sykdommer som hjerte- og karsykdommer, kreft og diabetes.
- Kroppen din bli kjempeglad for alle fibrene, vitaminene og næringsstoffene som finnes i et mer plantebasert kosthold.

## Finn ut mer
- [https://www.health.harvard.edu/staying-healthy/becoming-a-vegetarian](https://www.health.harvard.edu/staying-healthy/becoming-a-vegetarian)`,
    handprint_explanation: `MARKDOWN:
## Visste du at?
- Å invitere venner, familie og bekjente på en deilig vegetarmiddag kan hjelpe andre til å redusere sitt eget kjøttforbruk. 

## Effekt
- I følge psykologiforsker Per Espen Stoknes på BI, kan vi bruke våre sosiale nettverk til å påvirke de rundt oss.

## Les mer
- [https://www.bi.no/forskning/business-review/articles/2015/12/fem-mater-a-redde-kloden-pa/](https://www.bi.no/forskning/business-review/articles/2015/12/fem-mater-a-redde-kloden-pa/)`,
  },
  activity_food_36: {
    title: 'Jeg spiste kortreist mat i dag',
    description: `Registreres hver dag du er bevisst på hvor langt maten din transporteres og velger mat som produseres lokalt.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kortreist, lokalprodusert mat er en fordel fordi man begrenser transporten av matvarer og reduserer forurensningen som transporten medfører (klimagassutslipp, veibelastning, lokal forurensning som svevestøv og veisalt osv.). 
- Transportutslippene utgjør derimot en veldig liten klimaforskjell hvis det er større klimagassutslipp forbundet med en lokal produksjon sammenlignet med import av maten. Fra et CO\u2082 perspektiv er eksempelvis drivhusgrønnsaker varmet på fossil energi verre for miljøet enn om vi hadde importert den samme varen utenlands.

## Les mer
- [https://www.framtiden.no/myteknusing/er-kortreist-mat-mer-miljovennlig.html](https://www.framtiden.no/myteknusing/er-kortreist-mat-mer-miljovennlig.html)`,
  },
  activity_food_37: {
    title:
      'Jeg snakket med venner, familie eller kollegaer om bærekraftig mat i dag',
    description: `Registreres hver dag du snakker med noen om bærekraftig mat.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Å snakke med andre kan ha positive ringvirkninger som inspirerer dem til å selv kjøpe bærekraftig mat, samt fremsnakke bærekraftig mat til andre.
- Å snakke om bærekraft på flere plattformer kan hjelpe oss å finne de gode løsningene sammen. Et høyt fokus blant folk kan også hjelpe oss å akselerere overgangen til en grønnere hverdag.

## Les mer
- [https://www.weforum.org/agenda/2018/06/how-to-talk-about-climate-change-5-tips-from-the-front-lines/](https://www.weforum.org/agenda/2018/06/how-to-talk-about-climate-change-5-tips-from-the-front-lines/)
- [https://www.ted.com/talks/per_espen_stoknes_how_to_transform_apocalypse_fatigue_into_action_on_global_warming](https://www.ted.com/talks/per_espen_stoknes_how_to_transform_apocalypse_fatigue_into_action_on_global_warming)`,
  },
  activity_food_38: {
    title: 'Jeg spiste bærekraftig fisk i stedet for kjøtt til lunsj',
    description: `Registreres hver dag du har byttet ut kjøtt med fisk eller vegetar til lunsj.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Sjømat har et betydelig lavere CO\u2082-utslipp enn kjøtt. 
- Vær oppmerksom på hvilken type fisk du velger ved å bruke miljøsertifisert sjømatproduksjon som oppfyller miljøstandardene. Både sild, makrell, torsk eller sei har betydelig lavere avtrykk enn oppdtretslaks. 

## Dokumenterte effekter
- Beregningene er gjort ved å fjerne kaloriintaket fra en gjennomsnittlig innbygger i ditt land fra kjøttprodukter og overføre disse kaloriene til fiskeprodukter.
- Vi har lagt til grunn at 35% av kaloriinntaket kommer fra lunsj.

## Les mer
- [https://foodprint.org/issues/sustainable-seafood/](https://foodprint.org/issues/sustainable-seafood/) 
- [https://wwf.panda.org/get_involved/live_green/out_shopping/seafood_guides](https://wwf.panda.org/get_involved/live_green/out_shopping/seafood_guides)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
- Et bærekraftig fiskeforbruk kan forbedre helse og velvære betydelig.
- Å spise fisk kan hjelpe deg å redusere risikoen for hjertesykdommer, hjerneslag og diabetes.
- Fet fisk inneholder Omega-3 som er viktig for menneskers utvikling, og for noen også bidra til å redusere depresjon. Fet fisk er også en god kilde for vitamin D, som er viktig for å ta opp kalsuim. Dette hjelper kroppen vår å bygge og utvikle sterk benstruktur.

## Les mer
- [https://www.healthline.com/nutrition/11-health-benefits-of-fish#section7](https://www.healthline.com/nutrition/11-health-benefits-of-fish#section7)
- [https://ods.od.nih.gov/factsheets/VitaminD-HealthProfessional/](https://ods.od.nih.gov/factsheets/VitaminD-HealthProfessional/)`,
  },
  activity_food_39: {
    title: 'Jeg spiste fisk i stedet for kjøtt til middag i dag',
    description: `Registreres hver dag du spiser fisk i stedet for kjøtt til middag.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Sjømat har et betydelig lavere CO\u2082-utslipp enn kjøtt. 
- Vær oppmerksom på hvilken type fisk du velger ved å bruke miljøsertifisert sjømatproduksjon som oppfyller miljøstandardene. Både sild, makrell, torsk eller sei har betydelig lavere avtrykk enn oppdtretslaks. 

## Dokumenterte effekter
- Beregningene er gjort ved å fjerne kaloriintaket fra en gjennomsnittlig innbygger i ditt land fra kjøttprodukter og overføre disse kaloriene til fiskeprodukter.
- Vi har lagt til grunn at 45% av kaloriinntaket kommer fra middag.

## Les mer
- [https://foodprint.org/issues/sustainable-seafood/](https://foodprint.org/issues/sustainable-seafood/) 
- [https://wwf.panda.org/get_involved/live_green/out_shopping/seafood_guides](https://wwf.panda.org/get_involved/live_green/out_shopping/seafood_guides)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
- Et bærekraftig fiskeforbruk kan forbedre helse og velvære betydelig.
- Å spise fisk kan hjelpe deg å redusere risikoen for hjertesykdommer, hjerneslag og diabetes.
- Fet fisk inneholder Omega-3 som er viktig for menneskers utvikling, og for noen også bidra til å redusere depresjon. Fet fisk er også en god kilde for vitamin D, som er viktig for å ta opp kalsuim. Dette hjelper kroppen vår å bygge og utvikle sterk benstruktur.

## Les mer
- [https://www.healthline.com/nutrition/11-health-benefits-of-fish#section7](https://www.healthline.com/nutrition/11-health-benefits-of-fish#section7)
- [https://ods.od.nih.gov/factsheets/VitaminD-HealthProfessional/](https://ods.od.nih.gov/factsheets/VitaminD-HealthProfessional/)`,
  },
  activity_food_40: {
    title: 'Jeg spiste ute i dag',
    description: `Registreres hver dag du spiser på restaurant og bruker pengene dine på tjenester, service og kos i stedet for ting.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Du kan spise ute med god samvittighet? Å bruke pengene våre på tjenester i stedet for ting er i de fleste tilfeller miljøvennlig, og hyggelig. Gjør det ennå mer miljøvennlig ved å velge miljøbevisste spisesteder!

## Les mer
- [https://www.visitoslo.com/no/oslo-for-deg/gront-oslo/spis-gront/](https://www.visitoslo.com/no/oslo-for-deg/gront-oslo/spis-gront/)`,
  },
  activity_food_41: {
    title: 'Jeg drakk springvann fremfor flaskevann i dag',
    description: `Registreres hver dag du drikker vann fra springen i stedet for flaskevann.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Å drikke vann fra springen sparer miljøet for CO\u2082- utslipp relatert til fremstilling, produksjon av flasker, tapping og transport.

## Les mer
- [https://www.countyofkane.org/Recycling/Documents/TakeBackTheTap_web.pdf](https://www.countyofkane.org/Recycling/Documents/TakeBackTheTap_web.pdf)`,
  },
  activity_food_42: {
    title:
      'Jeg spurte butikken min om å få inn bærekraftig matvarer som mangler i sortimentet i dag',
    description: `Registreres hver dag du etterspør bærekraftige matvarer på butikken.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Visste du at?
- Ved å etterspørre bærekraftige matvarer forteller du produsenter at du vil at maten skal komme fra bærekraftige ressurser.

## Les mer
- [https://www.weforum.org/agenda/2018/06/how-to-talk-about-climate-change-5-tips-from-the-front-lines/](https://www.weforum.org/agenda/2018/06/how-to-talk-about-climate-change-5-tips-from-the-front-lines/)
- [https://www.ted.com/talks/per_espen_stoknes_how_to_transform_apocalypse_fatigue_into_action_on_global_warming](https://www.ted.com/talks/per_espen_stoknes_how_to_transform_apocalypse_fatigue_into_action_on_global_warming)`,
  },
  activity_food_43: {
    title: 'Jeg spiste vegansk til frokost i dag',
    description: `Registreres hver dag du har hatt en fiske-, kjøtt- og meierifri frokost.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøtt og meieriproduksjon fører til store CO\u2082e- utslipp på grunn av fôrdyrkingen (som i stor grad består av soya og mais), metanutslipp gjennom raping fra drøvtyggere og hugging av regnskog.
- Som eksempel har melk, yoghurt og ost et høyt utslipp per kalori. Det finnes mange gode alternativer til meieriprodukter fra hvete, ris, soya og nøtter. 

## Dokumenterte effekter
- Beregningen er gjort ved å fjerne ditt kaloriinntaket fra kjøtt, fisk og meieriprodukter, og overført disse kaloriene til grønnsaker, frukt og kornprodukter.
- Vi har lagt til grunn at 20% av kaloriintaket i løpet av en dag for en gjennomsnittsnordmann kommer fra frokost.

## Les mer
- [https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html](https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html)

## Tips til å komme i gang
- [https://www.vegansamfunnet.no/mattips/](https://www.vegansamfunnet.no/mattips/)
- [https://www.vegetarbloggen.no/category/veganske-oppskrifter/frokost/](https://www.vegetarbloggen.no/category/veganske-oppskrifter/frokost/)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
- Å redusere inntak av meieriprodukter med høyt fettinnhold, kan du forbedre helsen din og redusere risikoen for hjerte og karsykdommer, kreft og overvekt. 
- I en meierifri diett vil kroppen trenger en variasjon av frukt, grønnsaker, korn og meierifrie alternativer for å få i seg alt av vitaminer (særlig vitamin B) og mineraler som kroppen trenger.

## Les mer
- [https://www.hollandandbarrett.com/the-health-hub/food-drink/diets/dairy-free/keeping-healthy-dairy-free-diet/](https://www.hollandandbarrett.com/the-health-hub/food-drink/diets/dairy-free/keeping-healthy-dairy-free-diet/)`,
  },
  activity_food_44: {
    title: 'Jeg spiste vegansk til lunsj i dag',
    description: `Registreres hver dag du har hatt en fiske-, kjøtt- og meierifri lunsj.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøtt og meieriproduksjon fører til store CO\u2082e- utslipp på grunn av fôrdyrkingen (som i stor grad består av soya og mais), metanutslipp gjennom raping fra drøvtyggere og hugging av regnskog. Melk, yoghurt og ost har derfor et høyt utslipp per kalori. Det finnes mange gode alternativer til meieriprodukter fra hvete, ris, soya og nøtter. 

## Dokumenterte effekter
- Beregningen er gjort ved å fjerne ditt kaloriinntaket fra kjøtt- og meieriprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.
- Vi har lagt til grunn at 35% av kaloriintaket i løpet av en dag for en gjennomsnittsnordmann kommer fra lunsj. 

## Les mer
- [https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html](https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html)

## Tips til å komme i gang
- [https://vegetarmat.org/](https://vegetarmat.org/)
- [https://www.vegetarbloggen.no/](https://www.vegetarbloggen.no/)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
- Å redusere inntak av meieriprodukter med høyt fettinnhold, kan du forbedre helsen din og redusere risikoen for hjerte og karsykdommer, kreft og overvekt. 
- I en meierifri diett vil kroppen trenger en variasjon av frukt, grønnsaker, korn og meierifrie alternativer for å få i seg alt av vitaminer (særlig vitamin B) og mineraler som kroppen trenger.

## Les mer
- [https://www.hollandandbarrett.com/the-health-hub/food-drink/diets/dairy-free/keeping-healthy-dairy-free-diet/](https://www.hollandandbarrett.com/the-health-hub/food-drink/diets/dairy-free/keeping-healthy-dairy-free-diet/)`,
  },
  activity_food_45: {
    title: 'Jeg spiste vegansk til middag i dag',
    description: `Registreres hver dag du har hatt en fiske-, kjøtt- og meierifri middag.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Kjøtt og meieriproduksjon fører til store CO\u2082e- utslipp på grunn av fôrdyrkingen (som i stor grad består av soya og mais), metanutslipp gjennom raping fra drøvtyggere og hugging av regnskog.
- Som eksempel har melk, yoghurt og ost et høyt utslipp per kalori. Det finnes mange gode alternativer til meieriprodukter fra hvete, ris, soya og nøtter. 

## Dokumenterte effekter
- Beregningen er gjort ved å fjerne ditt kaloriinntaket fra kjøtt- og meieriprodukter, og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.
- Vi har lagt til grunn at 45% av kaloriintaket i løpet av en dag for en gjennomsnittsnordmann kommer fra middag. 

## Les mer
- [https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html](https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html)

## Tips til å komme i gang
- [https://vegetarmat.org/](https://vegetarmat.org/)
- [https://www.vegetarbloggen.no/](https://www.vegetarbloggen.no/)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
- Å redusere inntak av meieriprodukter med høyt fettinnhold, kan du forbedre helsen din og redusere risikoen for hjerte og karsykdommer, kreft og overvekt. 
- I en meierifri diett vil kroppen trenger en variasjon av frukt, grønnsaker, korn og meierifrie alternativer for å få i seg alt av vitaminer (særlig vitamin B) og mineraler som kroppen trenger.

## Les mer
- [https://www.hollandandbarrett.com/the-health-hub/food-drink/diets/dairy-free/keeping-healthy-dairy-free-diet/](https://www.hollandandbarrett.com/the-health-hub/food-drink/diets/dairy-free/keeping-healthy-dairy-free-diet/)`,
  },
  activity_food_46: {
    title: 'Jeg spiste byggryn fremfor ris i dag',
    description: `Registreres hver dag du har spist byggryn fremfor ris til alle dagens måltider.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Bygg er kanskje den mest klimaeffektive produksjonen av matenergi som finnes. Å produsere ris slipper ut fem ganger så mye klimagassutslipp som bygg. Bygg kan dyrkes langt nord i Norge, mens ris importeres langveis fra.

## Les mer
- [https://www.framtiden.no/gronne-tips/mat/slik-tar-du-miljovennlig-mat-pa-kornet.html](https://www.framtiden.no/gronne-tips/mat/slik-tar-du-miljovennlig-mat-pa-kornet.html)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
- Byggkornet har et naturlig høyt innhold av kostfiberet betaglukan, som har dokumenterte helseeffekter på kolesterol og blodsukker. I tillegg er dette kostfiberets molekyl kjempestort og fungerer som en feiekost i tarmen.

## Les mer
- [https://www.framtiden.no/gronne-tips/mat/slik-tar-du-miljovennlig-mat-pa-kornet.html](https://www.framtiden.no/gronne-tips/mat/slik-tar-du-miljovennlig-mat-pa-kornet.html)`,
  },
  activity_food_47: {
    title: 'Jeg valgte sild, makrell, torsk eller sei fremfor laks i dag',
    description: `Registreres hver dag du har spist sild, makrell, torsk eller sei til alle dagens måltider.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Hver sjette norske laks blir i dag spist i Asia eller USA, og store deler av fôret består av soya fra Brasil. Dette medfører store klimagassutslipp i produksjon, håndtering og transport.
- Norge er verdens største lakseprodusent, men vi har også mange andre mer bærekraftige fiskesorter vi burde spise mer av.

## Les mer
- [https://www.framtiden.no/201805097290/aktuelt/mat/norsk-lakseoppdrett-er-en-klimabombe.html](https://www.framtiden.no/201805097290/aktuelt/mat/norsk-lakseoppdrett-er-en-klimabombe.html)
- [https://www.framtiden.no/gronne-tips/mat/dette-er-verdens-mest-barekraftige-fiskemat.html](https://www.framtiden.no/gronne-tips/mat/dette-er-verdens-mest-barekraftige-fiskemat.html)
- [https://www.framtiden.no/gronne-tips/mat/klimagassutslipp-fra-matvarer.html](https://www.framtiden.no/gronne-tips/mat/klimagassutslipp-fra-matvarer.html)
- [https://www.framtiden.no/201703157119/aktuelt/mat/det-norske-lakseeventyret-blir-fort-et-mareritt-for-brasil.html](https://www.framtiden.no/201703157119/aktuelt/mat/det-norske-lakseeventyret-blir-fort-et-mareritt-for-brasil.html)`,
    health_explanation: `MARKDOWN:
## Visste du at? 
-  Sild er noe av det sunneste vi kan spise.

## Les mer
- [https://www.framtiden.no/gronne-tips/mat/dette-er-verdens-mest-barekraftige-fiskemat.html](https://www.framtiden.no/gronne-tips/mat/dette-er-verdens-mest-barekraftige-fiskemat.html)`,
  },
  activity_food_48: {
    title: 'Jeg etterspurte soyafri laks i dag',
    description: `Registreres hver dag du etterspør soyafri laks på butikken eller når du spiser ute.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Hver sjette norske laks blir i dag spist i Asia eller USA, og store deler av fôret består av soya fra Brasil. Dette medfører store klimagassutslipp i produksjon, håndtering og transport.
- Ved å etterspørre soyafri laks, forteller du produsentene at du vil at maten vår skal komme fra bærekraftige kilder.

## Les mer
- [https://www.framtiden.no/201703157119/aktuelt/mat/det-norske-lakseeventyret-blir-fort-et-mareritt-for-brasil.html](https://www.framtiden.no/201703157119/aktuelt/mat/det-norske-lakseeventyret-blir-fort-et-mareritt-for-brasil.html)
- [https://www.framtiden.no/201812207383/aktuelt/mat/pa-vei-mot-mer-barekraftig-laksefor.html](https://www.framtiden.no/201812207383/aktuelt/mat/pa-vei-mot-mer-barekraftig-laksefor.html)
- [https://www.framtiden.no/201812037376/aktuelt/mat/kun-salma-har-en-plan-for-a-redusere-soyaforbruket.html](https://www.framtiden.no/201812037376/aktuelt/mat/kun-salma-har-en-plan-for-a-redusere-soyaforbruket.html)`,
  },
  activity_food_49: {
    title: 'Jeg spiste mat i sesong i dag',
    description: `Registreres hver dag du velger matvarer i sesong.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- En god grunn til å spise mer sesongmat er at råvarene høstes i sin beste alder? Det betyr at når vi spiser sesongmat spiser vi maten når den smaker best!
- Samtidig begrenser det å lage og spise mat etter årstid og sesong energikrevende dyrking i drivhus, lagring av mat og lang transport av ferskvarer.

## Les mer
- [https://www.bama.no/storkjokken/sesongkalender/](https://www.bama.no/storkjokken/sesongkalender/)`,
  },
  activity_food_50: {
    title: 'Jeg byttet ut kumelk med ikke-animalske melkeprodukter i dag',
    description: `Registeres hver dag du bytter ut kumelk med ikke animalske melkeprodukter.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Selv om soya er problematisk som dyre- og fiskefor, er soya miljøvennlig og har et svært lavt klimafotavtrykk hvis det konsumeres direkte av mennesker.
- Det meste av soyaen brukt i vegetariske og veganske produkter er dyrket i EU og USA.

## Effekt
- Denne aktiviteten hjelper deg å teste ut veganske alternativer. Om du bytter ut alle meierprodukter i et måltid, kan du registrere veganer-aktivitetene som har CO\u2082-beregning. 

## Les mer
- [https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html](https://www.framtiden.no/gronne-tips/spor-oss/bor-jeg-unnga-a-spise-soya.html)`,
  },
  activity_food_51: {
    title: 'Jeg prøvde et vegetarisk kjøtterstatningsprodukt i dag',
    description: `Registeres hver dag du bytter ut kjøtt med et vegetarisk kjøtterstatningsprodukt.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Du kan erstatte alt eller noe av kjøttet med vegetariske proteinkilder og grønnsake som bønner, linser og kikerter.
- 43% of Norwegians say the want to reduce their meat consumption due to environmental and animal welfare reasons.

## Effekt
- Denne aktiviteten hjelper deg å teste ut vegetaratlternativer. Hvis du bytter ut kjøtt i et måltid med fisk eller vegetar, kan du registerer et av vegetar-måltidene som har CO\u2082-beregning. 

## Les mer
- [https://www.framtiden.no/gronne-tips/mat/klimagassutslipp-fra-matvarer.html](https://www.framtiden.no/gronne-tips/mat/klimagassutslipp-fra-matvarer.html)`,
  },
  activity_food_52: {
    title: 'Jeg spiste mer bærekraftig kjøtt i stedet fremfor storfe i dag',
    description: `Reigsteres hver dag du bytter ut storfe med mer bærekraftig kjøtt.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Visste du at?
- Vilt er det mest bærekraftige alternativet til storfekjøtt, og ivaretar stort sett dyrevelferden bedre enn ved annet dyrehold. Bestandene av elg, hjort og rådyr i Norge har aldri vært større, så selv om det totale kjøttforbruket må ned, kan viltkjøtt være en klimasmart erstatning for de gangene vi velger kjøtt.
- Vi spiser store mengder kjøttdeig i Norge, men det er store forskjeller på bærekraftspåvirkningen til de ulike kjøttypene. Velg heller økologisk kjøttdeig av svin eller kylling i stedet for storfe.

## Les mer
- [https://www.framtiden.no/gronne-tips/mat/tips-til-mer-barekraftig-kjott.html](https://www.framtiden.no/gronne-tips/mat/tips-til-mer-barekraftig-kjott.html)`,
  },
  activity_food_53: {
    title: 'Jeg spiste lokalt produsert frukt og grønt i dag',
    description:
      'Kan logges på dagers hvor mesteparten av frukt og grønt du spiser er fra regionale produsenter. Det er viktig å huske at besparelsen er avhengig av hvordan DU reiser for å handle maten, så velg miljøvennlig når du skal handle!',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Det er omstridt om lokalmat har særlig stor klimaeffekt, da besparelsen i transportutslipp ofte slettes av mindre effektiv logistikk i små, lokale produksjonskjeder. Det er allikevel mange sosiale fordeler med å støtte lokalt næringsliv.
- Transport er en relativt liten andel av matfotavtrykk. Derfor kan du spare mer ved å fokusere på hva du spiser, enn hvor det kommer fra.

## Hva vi antar
- I matberegningene våre har vi en tilleggsfaktor for transport på ca 10% opp på produksjonsutslippene. I denne aktiviteten antar vi at transportutslippene for alt av frukt og grønt du spiser i løpet av en dag, er null.
- Hvis du kjører lengre avstander for å skaffe lokalmat, kan vinningen gå opp i spinningen. Velg derfor matkasser, eller miljøvennlige transportmetoder når du skal handle.

## Tilleggsinformasjon
- [https://www.framtiden.no/tips/kjoep-mer-fra-din-lokale-bonde](https://www.framtiden.no/tips/kjoep-mer-fra-din-lokale-bonde)
- [https://ourworldindata.org/environmental-impacts-of-food#you-want-to-reduce-the-carbon-footprint-of-your-food-focus-on-what-you-eat-not-whether-your-food-is-local](https://ourworldindata.org/environmental-impacts-of-food#you-want-to-reduce-the-carbon-footprint-of-your-food-focus-on-what-you-eat-not-whether-your-food-is-local)`,
  },
  activity_food_54: {
    title: 'Jeg spiste lokal biff i stedet for importert i dag',
    description:
      'Kan logges på dager du kjøper storfekjøtt som er lokalprodusert, i stedet for storfekjøtt importert fra utlandet.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Netto utslipp av klimagasser fra storfekjøttproduksjon varierer globalt, avhengig av forvaltningsstrategien som er valgt (intensiv versus omfattende rotasjonsbeite, mer bærekraftig vs. ikke-bærekraftig fôr) og lokale miljøfaktorer som klima, jordtype samt lokale standarder for storfekjøttproduksjon og kulturelle påvirkninger, som raser og hva som er vanlig å fôre med.
- Det er viktig å huske på at lokalt storfekjøtt fortsatt har høyere utslipp enn andre proteinkilder (dvs. planteprotein som soya, fisk, kylling osv.). Derfor vil bytte fra storfekjøtt til mer bærekraftige proteinkilder ha større miljøfordeler enn å kjøpe lokalt storfekjøtt i stedet for importert.

## Hva vi antar
- Norsk storfekjøttproduksjon er mindre CO\u2082e-intensiv sammenlignet med global storfekjøttproduksjon som følge av bruk av lavkarbonhåndteringsstrategier for storfekjøttproduksjon, gunstige miljøfaktorer og lavere utslipp fra transport som følge av manglende import.

## Tilleggsinformasjon
- [https://onlinelibrary.wiley.com/doi/full/10.1111/gcb.15509?af=R](https://onlinelibrary.wiley.com/doi/full/10.1111/gcb.15509?af=R)`,
  },
  activity_food_55: {
    title: 'Jeg spiste vegansk i dag',
    description:
      'Kan logges på dager du avstår fra å spise kjøtt, fisk og meieriprodukter til alle måltider',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Husdyrhold er en viktig kilde til klimagassutslipp, hovedsakelig på grunn av metan som slippes ut av drøvtyggere som kuer og sauer, og endret arealbruk (hogst av skog for å skape plass til beitedyr)
- Å spise mer planter og mindre animalske produkter er en av de mest effektive måtene du kan redusere klimafotavtrykket på.
- Det er enklere enn noen gang å spise vegansk kost, siden det finnes en mengde veganske alternativer til mat som kjøtt og meieriprodukter.

## Hva vi antar
- Beregninger gjøres ved å fjerne kaloriinntaket ditt fra kjøtt, sjømat og meieriprodukter og overføre disse kaloriene til grønnsaker, frukt og kornprodukter.
– Sjekk ut klimakalkulatoren og tilhørende dokumentasjon for mer informasjon om nøyaktig hvor mye du kan spare ved å endre matvanene.

## Tilleggsinformasjon
- [Hvordan bli vegetarianer](https://www.framtiden.no/artikler/spis-mer-plantebasert)
- [Å gi opp meieriprodukter og kjøtt har en av de største konsekvensene for å redusere fotavtrykket ditt](https://ourworldindata.org/environmental-impacts-of-food#)`,
  },
  activity_food_56: {
    title: 'Jeg spiste hvitt kjøtt i stedet for rødt kjøtt i dag',
    description:
      'Kan logges på dager du erstatter rødt kjøtt med hvitt kjøtt til alle måltider',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Basert på funnene i denne [forskningsartikkelen](https://www.framtiden.no/tips/sjekk-hvilken-mat-som-er-best-for-miljoeet), er miljøpåvirkningen fra rødt kjøtt (biff og lam) marginal sammenliknet med den fra hvitt kjøtt (fjærfe, svinekjøtt). Dette skyldes delvis biologien til hvordan drøvtyggere fordøyer mat; fordøyelsen av drøvtyggere produserer mye metan, som er en mye kraftigere drivhusgass enn CO\u2082, selv om den er kortvarig. Det at husdyroppdrett er ressurskrevende forklarer også de høyere klimakostnadene.

## Hva vi antar
- Sammenlignet med kostholdet til en gjennomsnittlig innbygger i landet ditt, fjerner beregningen kaloriinntaket fra rødt kjøtt, og overfører disse kaloriene til hvite kjøttprodukter.

## Tilleggsinformasjon
- [Klimapåvirkningen til ulikt kjøtt](https://interactive.carbonbrief.org/what-is-the-climate-impact-of-eating-meat-and-dairy/)`,
  },
};
